import { render, staticRenderFns } from "./jxshany.vue?vue&type=template&id=3ad31dfe&scoped=true&"
import script from "./jxshany.vue?vue&type=script&lang=js&"
export * from "./jxshany.vue?vue&type=script&lang=js&"
import style0 from "./jxshany.vue?vue&type=style&index=0&id=3ad31dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad31dfe",
  null
  
)

export default component.exports